import React, { useState, useEffect } from 'react';
import styles from './Settings.module.css';
import { Modal, Form } from 'react-bootstrap';

interface SettingsProps {
  isOpen: boolean;
  onClose: () => void;
}

const Settings: React.FC<SettingsProps> = ({ isOpen, onClose }) => {
  const [showControls, setShowControls] = useState<boolean>(false);
  const [hasChanges, setHasChanges] = useState<boolean>(false);

  useEffect(() => {
    // Read initial value from localStorage
    const storedValue = localStorage.getItem('youtube_controls');
    setShowControls(storedValue === 'visible');
  }, []);

  const handleControlsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value === 'visible';
    setShowControls(newValue);
    setHasChanges(true);
  };

  const handleClose = () => {
    if (hasChanges) {
      // Store the new value
      localStorage.setItem('youtube_controls', showControls ? 'visible' : 'hidden');
      // Reload the page to apply changes
      window.location.reload();
    } else {
      onClose();
    }
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.settingGroup}>
          <h5>YouTube Player Controls</h5>
          <p className={styles.settingInfo}>
            The YouTube player controls are hidden by default.<br />
            Unhiding them allows you to manually <b>disable subtitles</b>.
          </p>
          <Form.Group>
            <Form.Check
              type="radio"
              name="controls"
              id="controls-hidden"
              label="Hidden"
              value="hidden"
              checked={!showControls}
              onChange={handleControlsChange}
            />
            <Form.Check
              type="radio"
              name="controls"
              id="controls-visible"
              label="Visible"
              value="visible"
              checked={showControls}
              onChange={handleControlsChange}
            />
          </Form.Group>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Settings; 